module.exports = __webpack_public_path__ + "img/kanta-full.a88ff55d.png";